import React from "react";
import { ActionButton, DefaultButton, Separator, Stack, TextField } from "@fluentui/react";
import Header from "../Common/Header";

interface IProductVideosProps {
    title?: string;
    videoUrls: string[];
    editMode?: boolean;
    onUpdate?: (videoUrls: string[]) => void;
}

// Add / edit / delete product video URLs. Lives in the product Media tab alongside
// ProductImages. When the owning storefront enables "Allow Playing Product Video",
// these URLs surface as a play button on the storefront product card/detail.
export const ProductVideos: React.FC<IProductVideosProps> = (props) => {
    const videoUrls = props.videoUrls ?? [];

    const updateUrl = (value: string, index: number) => {
        if (!props.onUpdate) return;
        props.onUpdate(videoUrls.map((v, i) => (i === index ? value : v)));
    };

    const deleteUrl = (index: number) => {
        if (!props.onUpdate) return;
        props.onUpdate(videoUrls.filter((_, i) => i !== index));
    };

    const addUrl = () => {
        if (!props.onUpdate) return;
        props.onUpdate([...videoUrls, ""]);
    };

    if (!props.editMode && videoUrls.length === 0) {
        return (
            <div>
                {props.title && <Separator>{props.title}</Separator>}
                <Header icon={"MyMoviesTV"}>No Product Videos Found</Header>
            </div>
        );
    }

    return (
        <div>
            {props.title && <Separator>{props.title}</Separator>}
            <Stack tokens={{ childrenGap: 8 }} style={{ maxWidth: 640 }}>
                {videoUrls.map((url, i) => (
                    <Stack key={i} horizontal verticalAlign="end" tokens={{ childrenGap: 8 }}>
                        <TextField
                            styles={{ root: { flexGrow: 1 } }}
                            label={i === 0 ? "Video URL" : undefined}
                            placeholder="https://www.youtube.com/watch?v=..."
                            value={url}
                            readOnly={!props.editMode}
                            borderless={!props.editMode}
                            onChange={(e, value) => updateUrl(value ?? "", i)}
                        />
                        {props.editMode && (
                            <ActionButton
                                iconProps={{ iconName: "Delete" }}
                                onClick={() => deleteUrl(i)}
                                ariaLabel="Delete video URL"
                            />
                        )}
                    </Stack>
                ))}
                {props.editMode && (
                    <div>
                        <DefaultButton iconProps={{ iconName: "Add" }} text="Add Video URL" onClick={addUrl} />
                    </div>
                )}
            </Stack>
        </div>
    );
};

export default ProductVideos;
